import axios from "axios";
import {API_BASE_URL_V2} from "../../services/config";
import {IProfileData} from "./i-profile-1";

// Get user profile
export const getUserProfileService = async (token: string) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.get(API_BASE_URL_V2 + "profile", config);

  return response.data;
};

/**
 * v2 profile update payload: camelCase, shortDescription → description
 *
 * @deprecated Use `src/features/profile/` repository + mapper instead.
 *
 * BUG: `displayName` is hardcoded to `null` — any update via this code path
 * will clear the user's display name. `linkedin` is also hardcoded to `null`.
 * This service is still called by the Redux `updateUserProfile` thunk in
 * `profile-slice.ts`, but that thunk is no longer used by the profile edit
 * form or onboarding (they now use React Query hooks from features/profile).
 * Remaining callers should be audited before removing this file.
 */
function mapProfileDataToV2Payload(profileData: IProfileData) {
  return {
    firstName: profileData.firstName,
    lastName: profileData.lastName,
    displayName: null as string | null,
    shortBio: profileData.shortBio,
    country: profileData.country,
    username: profileData.username,
    description: profileData.shortDescription,
    howDidYouFindUs: "",
    facebook: profileData.facebook ?? null,
    twitter: profileData.twitter ?? null,
    instagram: profileData.instagram ?? null,
    discord: profileData.discord ?? null,
    youtube: profileData.youtube ?? null,
    dribble: profileData.dribble ?? null,
    twitch: profileData.twitch ?? null,
    github: profileData.github ?? null,
    website: profileData.website ?? null,
    tiktok: profileData.tiktok ?? null,
    linkedin: null,
    behance: profileData.behance ?? null,
  };
}

// Update user profile
export const updateUserProfileService = async (
  profileData: IProfileData,
  token: string
) => {
  const payload = mapProfileDataToV2Payload(profileData);
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.post(API_BASE_URL_V2 + "profile", payload, config);

  return response.data;
};
